module.exports = __webpack_public_path__ + "static/media/pedra-deck-stroj.4150184f.png";